import "@beydesign/tokens/build/css/variables.css"
import * as Sentry from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app/App"
import "./index.css"
import "./styles/theme.css"
import { isDev, isProduction, isStaging } from "./utils/general"
import { isSentryEnabled } from "./utils/sentry"

if (isSentryEnabled) {
  Sentry.init({
    dsn: "https://79ef75a1ca8c8b89b2348537b2086ea6@o4507310462140416.ingest.de.sentry.io/4507310468169808",
    environment: isDev ? "development" : isStaging ? "staging" : "production",
    // Since v11 this defaults to true, which sends each captureMessage as an
    // exception titled after the function that called it, not the message
    attachStacktrace: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        showBranding: false,
        colorScheme: "dark",
        // Most callers are anonymous and never gave an email
        isEmailRequired: false,
        formTitle: "Report a problem",
        messagePlaceholder: "What went wrong, and what did you expect?",
        submitButtonLabel: "Send report",
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.01, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/bey\.chat/,
      /^https:\/\/api\.bey\.chat/,
      /^https:\/\/backend\.bey\.chat/,
      /^https:\/\/backend-dev\.bey\.chat/,
      /^https:\/\/dev\.bey\.chat/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.01,
    // Each error event from a buffered session uploads its replay, so the
    // error rate sets the replay volume
    replaysOnErrorSampleRate: 0.1,
  })
}

if (isProduction) {
  const gtmScript = document.createElement("script")
  gtmScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KQ3GSVNV');
  `
  document.head.insertBefore(gtmScript, document.head.firstChild)

  const gtmNoscript = document.createElement("noscript")
  const gtmIframe = document.createElement("iframe")
  gtmIframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-KQ3GSVNV"
  gtmIframe.height = "0"
  gtmIframe.width = "0"
  gtmIframe.style.display = "none"
  gtmIframe.style.visibility = "hidden"
  gtmNoscript.appendChild(gtmIframe)
  document.body.insertBefore(gtmNoscript, document.body.firstChild)

  const hubspotScript = document.createElement("script")
  hubspotScript.type = "text/javascript"
  hubspotScript.id = "hs-script-loader"
  hubspotScript.async = true
  hubspotScript.defer = true
  hubspotScript.src = "//js-eu1.hs-scripts.com/146556213.js"
  document.head.appendChild(hubspotScript)

  const clarityScript = document.createElement("script")
  clarityScript.type = "text/javascript"
  clarityScript.innerHTML = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "t8hb5ldszg");
  `
  document.head.appendChild(clarityScript)
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
